interface Props {
  label: string;
  action: { type: "url" | "route"; value: string };
}

export default function ChatCTA({ label, action }: Props) {
  const handleClick = () => {
    if (action.type === "url") {
      // Only allow http(s) URLs to prevent javascript: XSS
      if (/^https?:\/\//.test(action.value)) {
        window.open(action.value, "_blank", "noopener,noreferrer");
      }
    } else if (action.type === "route" && /^\/(?!\/|\\)/.test(action.value)) {
      // "//host" and "/\host" leave the site.
      window.location.href = action.value;
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-[var(--chat-space-04)] border border-[var(--chat-grey-100)] rounded-[var(--chat-corner-base)] px-[var(--chat-space-06)] py-[var(--chat-space-04)] hover:bg-[var(--chat-creme)] transition-colors"
    >
      <span className="text-[14px] font-semibold leading-[1.5] text-[var(--chat-black)]">
        {label}
      </span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="-rotate-90"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>
  );
}
